
import { InjectionToken } from '@angular/core';
import { Environment } from './models/environment';

export const APP_ENVIRONMENT = new InjectionToken<Environment>('AppEnvironment');